module.exports = __webpack_public_path__ + "static/media/fileColumn.9a7ebdb7.png";